export enum VirtualAreasEnum {
  ToyotaSalesOperationalArea = 1,
  ToyotaRegions = 2,
  ToyotaDelimitedArea = 3,
  ToyotaRegionals = 15,
  FordInfluencedArea = 25,
  MitsubishiOperationalAreas = 30,
  MitsubishiActingArea = 32
}
